import React from "react";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

const SemiCircularProgress = ({ percentage = 70, className = "" }) => {
  return (
    <div className={`relative overflow-hidden ${className}`}>
      {/* Full circle (but we only show top half due to overflow-hidden) */}
      <CircularProgressbar
        value={percentage}
        circleRatio={0.5}
        strokeWidth={20}
        styles={buildStyles({
          rotation: 0.75,
          pathTransitionDuration: 1.2,
          pathColor: `url(#gradient)`,
          trailColor: "#E5E7EB",
          strokeLinecap: "butt",
        })}
      />

      {/* Gradient definition */}
      <svg style={{ height: 0, position: "absolute" }}>
        <defs>
          <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="#4A9EFF" />
            <stop offset="100%" stopColor="#0012D9" />
          </linearGradient>
        </defs>
      </svg>

      {/* Percentage text */}
      <div className="absolute inset-0 flex items-end justify-center pb-0 sm:pb-1">
        <span
          className="text-3xl sm:text-4xl md:text-5xl font-bold text-[#4A9EFF]"
          style={{
            textShadow: "0 2px 4px rgba(0,0,0,0.1)",
            WebkitTextStroke: "1.5px #0012D9",
            paintOrder: "stroke fill",
          }}
        >
          {percentage}%
        </span>
      </div>
    </div>
  );
};

export default SemiCircularProgress;
